import {
  colors,
  headingSizes,
  headingType,
  weights,
} from '@components/theme/styles/index';
import { styled } from '@mui/material';
import { rem } from 'polished';

export const Title = styled('div')({
  fontSize: rem(headingSizes.h1),
  fontWeight: weights.semiBold,
  fontFamily: headingType,
  color: colors.grayDark2,
});

export const Subtitle = styled('div')({
  color: colors.grayDark2,
});

export const Email = styled('div')({
  color: colors.grayDark2,
  fontWeight: weights.semiBold,
  display: 'inline-block',
});

export const Footnote = styled('div')({
  color: colors.grayDark2,
});
